export type IHighlightElm = (elm: IjQueryElmOrHtmlElm, callbackFn?: IDCA.IGenericFunc) => void;

export function highlightElm(elm: IjQueryElmOrHtmlElm, callbackFn?: IDCA.IGenericFunc) {
  const $elm = $(elm);
  $elm.addClass('highlight-effect', 300, 'easeOutQuint', () => {
    $elm.removeClass('highlight-effect', 200, 'easeOutQuint');
    if (callbackFn && typeof callbackFn === 'function') {
      callbackFn();
    }
  });
}
